import { css } from '@emotion/core';
import React, { useEffect, useState } from 'react';

import Heading from '@/src/shared/components/Heading';
import ResultCard from '@/src/shared/components/ResultCard';
import { bp } from '@/styles';
import searchContent from '@/utils/searchContent';
import { getPath, windowScrollTo } from '@/utils/utils';

const styles = {
  container: css`
    > a {
      margin: 0 -16px 16px -16px !important;
      width: auto;
      max-width: fit-content;
      @media ${bp.md} {
        margin: 0 0 16px !important;
        width: 100%;
        max-width: 100%;
      }
    }
  `,
  header: css`
    margin-top: 32px;
    margin-bottom: 21px;
  `,
};

const CommitteePublications = props => {
  const [publications, setPublications] = useState([]);
  const { committees } = props;

  useEffect(() => {
    (async () => {
      try {
        if (committees.length) {
          const { results } = await searchContent(
            { committees, cat1Id: '9996,9997', meetingTypeId: 1, page: 1, pageSize: 3 },
            { cache: false }
          );
          setPublications(results);
          windowScrollTo({ top: 0 });
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [committees]);

  if (!committees.length || !publications.length) return null;

  return (
    <section css={styles.container}>
      <Heading css={styles.header} type={3} theme="primaryGray" weight="bolder">
        Your Most Recent Committee Resources
      </Heading>
      {publications.map(result => {
        const [as, href] = getPath(result.Cat1Id, result.SitePageId);
        const date = new Date(result.PublishDate).toLocaleDateString();
        return (
          <ResultCard
            key={result.SitePageId}
            truncate
            fullWidth
            href={href}
            as={as}
            iconId={result.IconId}
            title={result.PageTitle}
            subtitle={`${result.PublicationMaster ? `${result.PublicationMaster} | ` : ''}${date}`}
            summary={result.ExecutiveSummary}
            summaryLimit={250}
          />
        );
      })}
    </section>
  );
};

export default CommitteePublications;
